import React from 'react';
import { connect } from 'react-redux';
import { translate } from '../../../base/i18n/functions';
import { IconUsers } from '../../../base/icons/svg';
import AbstractButton from '../../../base/toolbox/components/AbstractButton';
import { close as closeParticipantsPane, open as openParticipantsPane } from '../../../participants-pane/actions.web';
import { closeOverflowMenuIfOpen } from '../../../toolbox/actions.web';
import { isParticipantsPaneEnabled } from '../../functions';
import { closeChat } from "../../../chat/actions.web";
/**
 * Implementation of a button for accessing participants pane.
 */
class ParticipantsPaneButtonMobile extends AbstractButton {
    /**
     * Initializes a new {@code ParticipantsPaneButtonMobile} instance.
     *
     * @param {Object} props - The read-only properties with which the new
     * instance is to be initialized.
     */
    constructor(props) {
        super(props);
        this.accessibilityLabel = 'toolbar.accessibilityLabel.participants';
        this.toggledAccessibilityLabel = 'toolbar.accessibilityLabel.closeParticipantsPane';
        this.icon = IconUsers;
        this.label = 'toolbar.participants';
        this.state = {
            isHovered: false
        };
    }
    /**
     * Indicates whether this button is in toggled state or not.
     *
     * @override
     * @protected
     * @returns {boolean}
     */
    _isToggled() {
        return this.props._isOpen;
    }
    /**
     * Indicates whether this button is in disabled state or not.
     *
     * @override
     * @protected
     * @returns {boolean}
     */
    _isDisabled() {
        return this.props._lobbyKnocking;
    }
    /**
     * Handles clicking the button, and toggles the participants pane.
     *
     * @private
     * @returns {void}
     */
    _handleClick() {
        const { dispatch, _isOpen, _isChatOpen } = this.props;
        dispatch(closeOverflowMenuIfOpen());
        if (_isOpen) {
            dispatch(closeParticipantsPane());
        }
        else {
            if (_isChatOpen) {
                dispatch(closeChat());
            }
            dispatch(openParticipantsPane());
        }
    }
    /**
     * Overrides AbstractButton's {@link Component#render()}.
     *
     * @override
     * @protected
     * @returns {React$Node}
     */
    render() {
        const { _isParticipantsPaneEnabled } = this.props;
        if (!_isParticipantsPaneEnabled) {
            return null;
        }
        return (React.createElement(React.Fragment, null, super.render()));
    }
}
/**
 * Maps part of the Redux state to the props of this component.
 *
 * @param {Object} state - The Redux state.
 * @returns {IProps}
 */
function mapStateToProps(state) {
    const { isOpen } = state['features/participants-pane'];
    const _isChatOpen = state['features/chat'].isOpen;
    const { knocking } = state['features/lobby'];
    return {
        _isOpen: isOpen,
        _isChatOpen: _isChatOpen,
        _isParticipantsPaneEnabled: isParticipantsPaneEnabled(state),
        _lobbyKnocking: knocking
    };
}
export default translate(connect(mapStateToProps)(ParticipantsPaneButtonMobile));
